import { PlanGateModal } from "components/website/components/planGate";
import type { ReactNode } from "react";
import type { RouteStop } from "./plannerLogic";
import { useGetThisTrip } from "./useGetThisTrip";
import styles from "./MadMonkey.module.scss";

interface GetTripButtonProps {
	/** the button's DOM id: a page can have several for the same route */
	id: string;
	stops: RouteStop[];
	name: string;
	/** "builder", or the ready-made route's id: what the `partner_trip_created` event reports */
	source: string;
	/** how the button looks; it is always a `button` */
	className: string;
	children: ReactNode;
}

/** The "Get this trip" button, with the sign-in modal it may open and the error it may leave behind. */
const GetTripButton = ({ id, stops, name, source, className, children }: GetTripButtonProps) => {
	const { request, status, gate, onLogin } = useGetThisTrip({ stops, name, source });
	return (
		<>
			<button type="button" id={id} className={className} onClick={request} disabled={status === "working"} aria-busy={status === "working"}>
				{status === "working" ? "Creating your trip…" : children}
			</button>
			{status === "error" && (
				<p className={styles.tripError} role="alert">
					We couldn&apos;t create your trip just now. Please try again.
				</p>
			)}
			<PlanGateModal
				gate={gate}
				title="Create a free account to get this trip"
				loginTitle="Log in to get this trip"
				initialView="register"
				allowMobile
				onLogin={onLogin}
			/>
		</>
	);
};

export default GetTripButton;
